import { Box, IconButton, Typography, Modal, Button } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  RedditShareButton,
  TelegramShareButton,
  XIcon,
  WhatsappShareButton,
  WorkplaceShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
  RedditIcon,
  TelegramIcon,
  WhatsappIcon,
  WorkplaceIcon,
  TwitterShareButton,
} from "react-share"
import Grid from '@mui/material/Grid2';

interface ShareModalProps {
  open: boolean
  onClose: () => void
  property: any
}

const ShareModal = ({ open, onClose, property }: ShareModalProps) => {
  const propertyUrl = window.location.href

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "70%", sm: "60%", md: "50%" },
          maxHeight: "80vh",
          padding: 4,
          backgroundColor: "white",
          borderRadius: 4,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          outline: "none",
          overflowY: "auto",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography
          variant="h5"
          sx={{
            mb: 3,
            fontWeight: "700",
            color: "#222",
            textAlign: "center",
            fontSize: { xs: "1.5rem", md: "1.9rem" },
          }}
        >
          Compartir propiedad en redes sociales
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "stretch",
            borderTop: "1px solid #e0e0e0",
            pt: 2,
            width: "100%",
            gap: 2,
          }}
        >
          {/* Imagen */}
          <Box
            component="img"
            src={property.photos[0]}
            alt={property.title}
            sx={{
              width: { xs: "100%", sm: "30%" },
              height: "auto",
              borderRadius: 1,
              objectFit: "cover",
              maxHeight: "120px",
            }}
          />

          {/* Detalles */}
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {/* Título */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 1,
                textOverflow: "ellipsis",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                {property.title}
              </Typography>
            </Box>

            {/* Dirección */}
            <Box
              sx={{
                marginBottom: 1,
                textOverflow: "ellipsis",
              }}
            >
              <Typography variant="body2" sx={{ color: "gray" }}>
                {property.address_Description}
              </Typography>
            </Box>

            {/* Precio y Categoría */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                {`Precio: ₡${property.price.toLocaleString("es-CR")}`}
              </Typography>
              <Typography variant="body2" sx={{ color: "gray" }}>
                {property.categoryName}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Grid container spacing={2} p={2} justifyContent="center" alignItems="center" mt={1}>
          {[
            { Component: FacebookShareButton, Icon: FacebookIcon, text: "Facebook" },
            { Component: TwitterShareButton, Icon: XIcon, text: "X" },
            { Component: WhatsappShareButton, Icon: WhatsappIcon, text: "WhatsApp" },
            { Component: EmailShareButton, Icon: EmailIcon, text: "Email" },
            { Component: LinkedinShareButton, Icon: LinkedinIcon, text: "LinkedIn" },
            { Component: PinterestShareButton, Icon: PinterestIcon, text: "Pinterest" },
            { Component: TelegramShareButton, Icon: TelegramIcon, text: "Telegram" },
            { Component: RedditShareButton, Icon: RedditIcon, text: "Reddit" },
            { Component: WorkplaceShareButton, Icon: WorkplaceIcon, text: "Workplace" },
          ].map(({ Component, Icon, text }) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={text} display="flex" justifyContent="center" flexWrap={"wrap"}>
              <Component url={propertyUrl} title={property?.title} media={""}>
                <Button
                  startIcon={<Icon size={32} round={true} />}
                  sx={{
                    width: "150px",
                    minHeight: "70px",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                    color: "#333",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    textTransform: "none",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    transition: "background-color 0.3s, transform 0.2s",
                    "&:hover": {
                      backgroundColor: "#66ffcc",
                      transform: "translateY(-2px)",
                    },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "stretch",
                  }}
                >
                  {text}
                </Button>
              </Component>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  )
}

export default ShareModal
